// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
// Mustache的 tpl 语法，安装 Mustache Templates - Syntax Highlighting, Snippets & Autocomplete 可高亮
import React from 'react';
import { KeepAliveContext,
  TabConfig
} from './context';

const KeepAliveLayout = (props)=>{
  const keepElements = React.useRef<any>({});
  const [cacheKeyMap, setCacheKeyMap] = React.useState({});
  const [tabNameMap, setTabNameMap] = React.useState({});
  const [keepalive, setKeepalive] = React.useState([/^(?!(\/saas-ticket|\/email-ticket|\/care-ticket|\/knowledge-base|\/system|\/core-config|\/)$).+/]);

  // 消除页面页面切换时内存泄漏的 hack
  function triggerCloseBorEvent(e?: any) {
    // 卸载之前先转移焦点，从而让页面被卸载时，不会因为引用问题导致页面泄漏
    e?.preventDefault?.();
    e?.stopPropagation?.();
    e?.nativeEvent?.stopImmediatePropagation?.();
    document.activeElement?.blur();
    document.getElementById('fixed-global-focus-input')?.focus();
    document.getElementById('fixed-global-focus-input')?.click();
  }

  function dropByCacheKey(path: string) {
    // 触发关闭之前事件
    triggerCloseBorEvent();
    if(keepElements.current[path.toLowerCase()]){
      delete keepElements.current[path.toLowerCase()];

      // 同步删除缓存
      let tabList = Object.keys(keepElements.current) || [];
      tabList = tabList.filter((tag) => tag !== path.toLowerCase())
      window.__keepalive_tabs_list__ = tabList;
      sessionStorage.setItem('__keepalive_tabs_list__', JSON.stringify(tabList));
      tabList = null;
    }
  }

  function addCacheKey(path: string, name: string, icon: string, index?: number) {
    if(!keepElements.current[path.toLowerCase()]){
      keepElements.current[path.toLowerCase()] = {
        index: index || Object.keys(keepElements.current).length,
        children: null,
        name: name || path,
        icon: icon,
        location: null,
        closable: true,
      }
      setCacheKeyMap(cacheKeyMap => ({
        ...cacheKeyMap,
        [path.toLowerCase()]: Math.random()
      }))
    } else {
      keepElements.current[path.toLowerCase()].index =  index || keepElements.current[path.toLowerCase()].index;
    }
  }

  /**
   * 关闭当前tab左侧的所有tab
   * @param path
   */
  function dropLeftTabs(path: string) {
    const currentIndex = keepElements.current[path.toLowerCase()].index;

    const leftTabs = Object.entries(keepElements.current).filter(
      ([_, { index, closable }]) => index < currentIndex & closable
    );

    // 挨个删除
    leftTabs.forEach(([key]) => {
      dropByCacheKey(key);
    });

    // 遍历剩下的keepElements，修改它们的index
    Object.entries(keepElements.current).forEach(([_, item]) => {
      item.index = item.index - leftTabs.length;
    });
    refreshTab(path);
  }

  /**
   * 关闭当前tab右侧的所有tab
   * @param path
   */
  function dropRightTabs(path: string) {
    const currentIndex = keepElements.current[path.toLowerCase()].index;

    const rightTabs = Object.entries(keepElements.current).filter(
      ([_, { index, closable }]) => index > currentIndex & closable
    );

    // 挨个删除
    rightTabs.forEach(([key]) => {
      dropByCacheKey(key);
    });

    // 遍历剩下的keepElements，修改它们的index
    Object.entries(keepElements.current).forEach(([_, item], index) => {
      item.index = index;
    });
    refreshTab(path);
  }

  /**
   * 关闭除当前tab外的所有tab
   * @param path
   */
  function dropOtherTabs(path: string) {
    const currentIndex = keepElements.current[path.toLowerCase()].index;

    // 遍历keepElements
    Object.entries(keepElements.current).forEach(([key, { index, closable }]) => {
      if (index != currentIndex & closable) {
        dropByCacheKey(key);
      }
    });
    // 只剩当前tab，需要修改它的index为0
    keepElements.current[path.toLowerCase()].index = 0;
    refreshTab(path);
  }

  /**
   * 重载tab页面
   * @param path
   */
  function refreshTab(path: string) {
    triggerCloseBorEvent();
    setCacheKeyMap((cacheKeyMap) => ({
      ...cacheKeyMap,
      [path.toLowerCase()]: Math.random(),
    }));
  }

  /**
   * 修改当前tab
   * @param path
   */
  function updateTab(path: string, config: TabConfig) {
    if (keepElements.current[path.toLowerCase()]) {
      keepElements.current[path.toLowerCase()] = {
        ...keepElements.current[path.toLowerCase()],
        ...config,
      }

      setTabNameMap((tabNameMap) => ({
        ...tabNameMap,
        [path.toLowerCase()]: Math.random(),
      }));
    }
  }

  return (
    <KeepAliveContext.Provider
      value={ {
        keepalive,
        setKeepalive,
        keepElements,
        cacheKeyMap,
        dropByCacheKey,
        tabNameMap,
        dropLeftTabs,
        dropRightTabs,
        dropOtherTabs,
        refreshTab,
        updateTab,
        addCacheKey,
      }}
      {...props}
    />
  )
}
export function rootContainer(container) {
  return React.createElement(KeepAliveLayout, null, container);
}
